// extracted by mini-css-extract-plugin
export default {"title":"penjual-non-century_title__qIZDN","mb-40":"penjual-non-century_mb-40__PMyXO"};